<template>
    <!-- 系统管理员-首页 99 -->
    <div class="boss">
        <!-- 上半部分 -->
        <div class="top_content">
            <el-row :gutter="20">
                <!-- 上半部-左卡片 -->
                <el-col :span="11">
                    <el-card class="box_card_l">
                        <p class="box_card_text">校园信息</p>
                        <el-card class="box_card_content" style="margin-bottom: 20px; background-color: rgba(234, 244, 255, 1);">
                            <div class="content">
                                <div class="content_div_l">学校</div>
                                <div class="content_div_r">{{ infoData.school_count }}</div>
                            </div>
                        </el-card>

                        <el-card class="box_card_content" style="background-color: rgba(235, 250, 242, 1); height: 150px;">
                            <div class="content margin-b">
                                <div class="content_div_l">教师</div>
                                <div class="content_div_r">{{ infoData.teacher_count }}</div>
                            </div>

                            <div class="content margin-b">
                                <div class="content_div_l">学生</div>
                                <div class="content_div_r">{{ infoData.student_count }}</div>
                            </div>

                            <div class="content margin-b">
                                <div class="content_div_l">家长绑定</div>
                                <div class="content_div_r">{{ infoData.family_count }}</div>
                            </div>
                        </el-card>
                    </el-card>
                </el-col>

                <!-- 上半部-右卡片 -->
                <el-col :span="13">
                    <!-- 上半部-右卡片 -->
                    <el-card class="box_card_r">
                        <p class="box_card_text">系统活跃趋势</p>

                        <!-- 右-可视图 -->
                        <div ref="sysActive" style="height: 250px;"></div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <!-- 下半部分 -->
        <div class="content_boss">
            <el-row :gutter="20">
                <el-col :span="11">
                    <!-- 下半部-左卡片 -->
                    <el-card class="box_card_l">
                        <p class="box_card_text">设备信息</p>
                        <!-- 设备信息-下部分文字+图 -->
                        <div class="echart_center_text">
                            <div>
                                <el-row>
                                    <el-col :span="8" class="setting_text">
                                        <span class="setting_left_text">摄像头</span>
                                        <span>安装总数：{{ infoData.camera_count }}台</span>
                                    </el-col>
                                    <el-col :span="8" class="setting_text">
                                        <span class="setting_left_text">电子铃声</span>
                                        <span>安装总数：{{ infoData.audio_count }}台</span>
                                    </el-col>
                                    <el-col :span="8" class="setting_text">
                                        <span class="setting_left_text">电子班牌</span>
                                        <span>安装总数：{{ infoData.class_screen_count }}台</span>
                                    </el-col>
                                    <el-col :span="8" class="setting_text">
                                        <span class="setting_left_text">屏幕</span>
                                        <span>安装总数：{{ infoData.screen_count }}台</span>
                                    </el-col>
                                    <el-col :span="8" class="setting_text">
                                        <span class="setting_left_text">语言报警</span>
                                        <span>安装总数：{{ infoData.warn_light_count }}台</span>
                                    </el-col>
                                </el-row>
                            </div>

                        </div>

                        <!-- 底部-设备信息-echarts -->
                        <div class="echart_bottom">
                            <div style="text-align: center;margin: 5px 0px;">
                                <span style="text-align: center; font-size: 17px;font-weight: 700;font-style: 20px;">共<span style="margin: 0 10px;">{{ infoData.device_count }}</span>台
                                </span>
                            </div>

                            <!-- 左-可视饼图 -->
                            <div ref="deviceInfo" style="height: 250px;"></div>
                        </div>
                    </el-card>
                </el-col>

                <el-col :span="13">
                    <!-- 下半部-右卡片 -->
                    <el-card class="box_card_r">
                        <p class="box_card_text">学校：学段比例</p>
                        <!-- 学校：学段比例-下部分文字+图 -->
                        <div class="echart_center_text">
                            <div>
                                <el-row>
                                    <el-col :span="8" class="setting_text" v-for="item in infoData.school_type_count" :key="item.name">
                                        <!-- 学段+个数 -->
                                        <span class="setting_left_text">{{ item.name }}</span>
                                        <span>{{ item.count }}</span>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>

                        <!-- 底部-设备信息-echarts -->
                        <div class="echart_bottom">
                            <div style="text-align: center;margin: 5px 0px;">
                                <span style="text-align: center; font-size: 17px;font-weight: 700;font-style: 20px;">共<span style="margin: 0 10px;">{{ infoData.school_count }}</span>家学校
                                </span>
                            </div>

                            <!-- 右-可视饼图 -->
                            <div ref="schoolPeriod" style="height: 250px;"></div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import {
    systemAdminHomeApi, //资源
} from '@/api/index' //接口
export default {
    data() {
        return {
            infoData: {},  //文字信息+个数台
            sysDate: [], //系统活跃条形图-x横坐标
            parent_count: [],//系统活跃条形图-家校互通
            teacher_count: [],//系统活跃条形图-校务系统

            liner: {},// 定义条形图，每条数据渐变色

        }
    },

    mounted() {
        this.changeColor();//条形图渐变颜色
        this.resView() //资源
    },

    methods: {

        changeColor() {
            this.linear = {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0, color: '#02bcff' // 0% 处的颜色
                }, {
                    offset: 1, color: '#5555ff' // 100% 处的颜色
                }],
                global: false // 缺省为 false
            };
        },

        // 资源
        async resView() {
            let datas = {
                node_type: 0,
            }
            const res = await this.axios.post(systemAdminHomeApi, datas);
            if (res.data.code == 1) {
                this.infoData = JSON.parse(JSON.stringify(res.data.data));//所有数据

                const deviceKeys = ['camera_count', 'audio_count', 'class_screen_count', 'screen_count', 'warn_light_count'];
                const arr1 = [{ 'camera_count': '摄像头' }, { 'audio_count': '电子铃声' }, { 'class_screen_count': '电子班牌' }, { 'screen_count': '屏幕' }, { 'warn_light_count': '语音警报' }];

                console.log(deviceKeys);

                // 根据设备的key，取得需要的数据
                this.infoData.deviceEchartsData = deviceKeys.map(item => ({
                    value: this.infoData[item],
                    name: item
                }));

                const mapping = Object.assign({}, ...arr1);

                // 将设备的key替换成汉字
                this.infoData.deviceEchartsData.forEach(item => {
                    item.name = mapping[item.name];
                });

                // 学段-饼图转换name、value为饼图固定
                this.infoData.schoolEchartsData = [];
                this.infoData.school_type_count.forEach(item => {
                    this.infoData.schoolEchartsData.push(
                        { name: item.name, value: item.count }
                    )
                })
                // 组装数据结束----------------------------

                // 系统活跃模块-echarts
                this.sysDate = this.infoData.active.map(obj => obj.name);//系统活跃-横坐标
                this.parent_count = this.infoData.active.map(obj => obj.parent_count);//家校互通
                this.teacher_count = this.infoData.active.map(obj => obj.teacher_count);//校务系统

                // 初始化图表
                this.initActiveChart();//系统活跃趋势图表数据
                this.initDeviceChart();//设备信息图表数据
                this.initSchoolChart();//学校学段比例图表数据
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },

        // 系统活跃趋势-条形图图表数据
        initActiveChart() {
            const chartEl = this.$refs.sysActive  // 获取对应的DOM元素
            const chart = echarts.init(chartEl)  // 创建 ECharts 实例

            // 设置图表配置项和数据
            const options = {
                //提示框取默认值，即鼠标移动到柱状图会显示内容
                tooltip: {
                    // axis轴线触发，item 当前项触发
                    trigger: 'axis',//鼠标移动时提示框(触发类型)
                    //坐标轴指示器，坐标轴触发有效
                    axisPointer: { //鼠标移动时-水平线及y轴对应值
                        type: 'cross',//默认为line，line直线，cross十字准星，shadow阴影
                        crossStyle: {//鼠标移动时，虚线颜色
                            color: '#999'
                        }
                    }
                },
                // 统计图-图例
                legend: {
                    data: ['校务系统', '家校互通'],
                    // 数组中每一个元素都是字符串，且需要与series里面的元素的name的值一致

                    // itemHeight: 6, // 图例的高度
                    // itemWidth: 16, // 图例的宽度
                    // x: "center", //居中显示
                    // inactiveColor: "rgba(0,0,0,0.3)", // 图例关闭后的颜色
                    // textStyle: {
                    //     fontSize: 12,
                    //     color: "#0B9295", // 图例的文字颜色
                    //     padding: [3, 0, 0, 0],
                    // },  
                },

                // 设置柱状图-在整个echart模块里的位置(大小比例)
                grid: {
                    top: "20%",
                    bottom: "0%",
                    left: "5%",
                    right: "5%",
                    containLabel: true
                },

                // title: { //图表的标题
                //     text: '成绩',
                //     textStyle: {
                //         color: 'red'
                //     },
                //     borderWidth: 5,//边框宽度
                //     borderColor: 'yellow',//边框颜色
                //     borderRadius: 30, //边框圆角
                //     left: 100,//位置偏移
                //     top: 50
                // },

                // toolbox: {// 右上角-功能设置切换
                //     // 显示工具箱
                //     show: true,
                //     feature: {
                //         // 数据缩放
                //         dataZoom: {
                //             yAxisIndex: 'none'
                //         },
                //         // 数据视图只读
                //         dataView: { readOnly: false },
                //         saveAsImage: {},//开启了下载为图片，即使什么都不配，也会出现该功能
                //         restore: {},  //还原视图为最初-重置
                //         //图形类型切换
                //         magicType: {
                //             type: ['bar', 'line']
                //         }
                //     },
                // },

                // x坐标 日期
                xAxis: [
                    {
                        type: 'category',//轴目类，即x轴上列出的是数据的分类，因此是需要data属性
                        data: this.sysDate,
                        axisPointer: {//鼠标移动时-水平线及y轴对应值
                            type: 'shadow',//默认为line，line直线，cross十字准星，shadow阴影
                        },
                        // scale: true, // 使得数值轴脱离0值，自动调整范围，y轴不再从0开始
                        // boundaryGap:false // 使得x轴的第一个元素紧挨y轴
                    }
                ],
                // y坐标 数据
                yAxis: [
                    {
                        type: 'value',// 数值轴，不需要设置data了，会自动根据实际数据自动确定范围
                        name: '访问量',
                        min: 0,
                        // max: 250,
                        // interval: 50,
                        // scale: true, // 使得数值轴脱离0值，自动调整范围，y轴不再从0开始
                        axisLabel: { //y轴数值
                            formatter: '{value}'//后面可加单位
                        }
                    }
                ],

                series: [
                    {
                        name: '校务系统',
                        type: 'bar',
                        tooltip: { //鼠标移动-框中提示这一类的数据
                            valueFormatter: function (value) {
                                return value + '次';
                            }
                        },
                        data: this.teacher_count,

                        // color:["#ac4cff"],
                        // itemStyle: { //条形图由下往上渐变
                        //     color: this.linear,
                        //     borderRadius: [30, 30, 0, 0]
                        // }

                        // markPoint: {// 最大最小-标记点
                        //     data: [
                        //         {
                        //             type: 'max',
                        //             name: '最高分'
                        //         },
                        //         {
                        //             type: 'min',
                        //             name: '最低分'
                        //         }
                        //     ]
                        // },

                        // markLine:// 系列平均线
                        // {
                        //     data: [{
                        //         type: 'average',
                        //         name: '平均分',
                        //     }]
                        // },
                        // stack: true,//两条形图堆叠，需两部分都设置此属性
                    },

                    {
                        name: '家校互通',
                        type: 'bar',
                        tooltip: {
                            valueFormatter: function (value) {
                                return value + '次';
                            }
                        },
                        data: this.parent_count,

                        // stack: true,//两条形图堆叠，需两部分都设置此属性
                        // label: { //条形图，每条数据值
                        //     show: true,//是否显示
                        //     rotate: 0,//旋转
                        //     position: 'outside',//显示在图像里外,insideRight现实中里面右侧
                        //     formatter: "{a}\n{c}分",//formmater格式, \n 代表换行，{a}系列名 "陈康" {b}数值名 "vue"  {c}代表上方y轴对应data数值  80
                        // },
                        // barWidth: 20//当前柱状图的宽度
                    },
                    {
                        name: '校务系统',
                        type: 'line',//样式为折现型
                        yAxisIndex: 0,
                        tooltip: {
                            show: false,
                        },
                        data: this.teacher_count,

                        // smooth: true,//拆线会变得比较光滑
                        // lineStyle: {//设置线型
                        //     color: 'red',//线颜色
                        //     type: 'dashed', //虚线，默认为直线
                        // },
                        // areaStyle: {//被折线所包起来的区域
                        //     color: 'pink'
                        // },

                        // lineStyle: {  //折现渐变
                        //     color: this.linear,
                        //     borderRadius: [30, 30, 0, 0]
                        // }
                    },
                    {
                        name: '家校互通',
                        type: 'line',
                        yAxisIndex: 0,
                        tooltip: {
                            show: false,
                        },
                        data: this.parent_count,
                    },
                ],
            };

            chart.setOption(options)  // 设置图表配置项
        },

        // 设备信息-饼图表数据
        initDeviceChart() {
            const chartEl = this.$refs.deviceInfo  // 获取对应的DOM元素
            const chart = echarts.init(chartEl)  // 创建 ECharts 实例

            // 设置图表配置项和数据
            const options = {
                // echarts图标对图形的解释部分
                legend: {
                    // orient设置图例的朝向:vertical垂直显示，horizontal 水平显示,不设置默认是水平
                    orient: 'vertical',
                    // left: 'right',
                    x: 'right',//图例在整个盒子中的位置
                    y: 'top',
                    // // 图例的某个选项的数据默认是显示还是隐藏，键值对
                    // selected: {
                    //     '语言警报': false,
                    //     '屏幕': false
                    // },
                    // // 控制每一项的间距，也就是图例之间的距离，属性值为数值，不带单位
                    // itemGap: 10,
                    // // 控制图例图形的高度,属性值为数字，不加单位
                    // // itemHeight: 5,
                    // textStyle: {//图例文字样式
                    //     color: 'black',
                    //     fontSize: '12px',
                    //     fontWeight: 400,
                    // },
                },

                series: [
                    {
                        name: '设备信息 饼图图表数据',//不在页面显示
                        type: 'pie',//类型为饼图
                        // radius: ['50%', '70%'],//饼图的半径，数组的第一项是内半径，第二项是外半径。支持设置成百分比。
                        center: ['50%', '50%'],//饼图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标。支持设置成百分比，设置成百分比时第一项是相对于容器宽度，第二项是相对于容器高度。
                        itemStyle: {// 每个扇区的样式
                            borderRadius: 5,//每块扇子的圆弧
                            borderColor: '#fff',// 每块之间的缝隙颜色
                            borderWidth: 5//缝隙宽度
                        },
                        label: {// 饼图图形上的文本标签
                            show: true,
                            position: 'outside',//标签的位置
                            formatter: function (arg) {
                                return arg.data.name + arg.percent + '%'
                                // arg.percent 自动换算对应的百分比，也可写成arg.data.value
                            },
                            // // 定义样式（富文本）,改变formatter的文字样式
                            // rich:{
                            // 	big:{
                            // 		color:"#f70",
                            // 		fontSize:"48px",
                            // 		fontWeight:900,
                            // 	},
                            // 	small:{
                            // 		color:"#f70"
                            // 	}
                            // }
                        },
                        // 饼图的数据 ，name为标签名，value为数量
                        data: this.infoData.deviceEchartsData
                    }
                ]
            };

            chart.setOption(options)  // 设置图表配置项
        },

        // 学校：学段比例-饼图表数据
        initSchoolChart() {
            const chartEl = this.$refs.schoolPeriod  // 获取对应的DOM元素
            const chart = echarts.init(chartEl)  // 创建 ECharts 实例

            // 设置图表配置项和数据
            const options = {
                legend: {
                    orient: 'vertical',
                    left: 'right'
                },
                series: [
                    {
                        name: '学校学段 饼图图表数据',
                        type: 'pie',//类型为饼图
                        // radius: [50, 250],//饼图的半径，数组的第一项是内半径，第二项是外半径。支持设置成百分比。
                        center: ['50%', '50%'],//饼图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标。支持设置成百分比，设置成百分比时第一项是相对于容器宽度，第二项是相对于容器高度。
                        // 每个扇区的样式
                        itemStyle: {
                            borderRadius: 5,
                            borderColor: '#fff',
                            borderWidth: 5
                        },
                        // 饼图图形上的文本标签
                        label: {
                            show: true,
                            position: 'outside',//标签的位置
                            formatter: function (arg) {
                                return arg.data.name + arg.value
                            },
                        },
                        // 饼图的数据 ，name为标签名，value为数量
                        data: this.infoData.schoolEchartsData
                    }
                ]
            };

            chart.setOption(options)  // 设置图表配置项
        },

    }
}
</script>

<style lang="scss" scoped>
// 系统管理员-首页
.boss {
    height: 87vh;
    overflow-y: auto;
    padding: 20px;
    background-color: #eee;
}

// 上半部分
.top_content {
    min-width: 1380px;
    // 左边卡片---------------------------------
    .box_card_l {
        border-radius: 10px;
        margin-right: 20px;
        height: 328px;

        // 左上-蓝文字
        .box_card_text {
            color: #81d3f8;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 10px;
        }

        .box_card_content {
            border-radius: 10px;

            .content {
                display: flex;
                justify-content: space-between;

                .content_div_l {
                    color: #555555;
                    font-size: 20px;
                    font-weight: 600;
                }

                .content_div_r {
                    color: #0b7efa;
                    font-size: 20px;
                    font-weight: 600;
                }
            }

            // 绿框中-每行距离下外边距
            .margin-b {
                margin-bottom: 13px;
            }
        }
    }

    // 右边卡片--------------------------------
    .box_card_r {
        // width: 55%;
        border-radius: 10px;
        height: 328px;

        // 左上-蓝文字
        .box_card_text {
            color: #81d3f8;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 10px;
            // border: 1px solid red;
        }
    }
}

// 下半部分
.content_boss {
    min-width: 1380px;
    margin-top: 20px;
    width: 100%;

    // display: flex;
    // 左卡片
    .box_card_l {
        border-radius: 10px;
        margin-right: 20px;

        // 卡片左上角-文字
        .box_card_text {
            font-size: 20px;
            font-weight: 600;
            color: #81d3f8;
        }

        // echart图
        .echart_center_text {
            width: 100%;
            // 左部分文字-展位50%
            .setting_text {
                display: flex;
                align-items: center;
                //border: 1px solid green;
                padding: 10px 20px 10px 20px;
                min-width: 220px;

                // margin-left: 10px;
                // 设备文字大样式
                .setting_left_text {
                    font-size: 16px;
                    font-weight: 600;
                    color: rgb(60, 60, 60);
                    margin-right: 10px;
                }
            }

            // 下边可视图
            .echart_bottom {
                margin-top: 10px;

                .a {
                    display: inline-block;
                    height: 310px;
                    width: 100%;
                    background-color: rgb(241, 222, 222);
                }
            }
        }
    }

    // 右卡片

    .box_card_r {
        width: 100%;
        // height: 100%;
        border-radius: 10px;

        // 卡片右上角-文字
        .box_card_text {
            font-size: 20px;
            font-weight: 600;
            color: #81d3f8;
        }

        // 左部分文字-展位50%
        .setting_text {
            display: flex;
            align-items: center;
            //border: 1px solid green;
            padding: 10px 20px 10px 20px;

            // margin-left: 10px;
            // 设备文字大样式
            .setting_left_text {
                font-size: 16px;
                font-weight: 600;
                color: rgb(60, 60, 60);
                margin-right: 10px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/homePage/systemAdminHomePage/systemAdminHome.vue